import { Component } from '@angular/core';

@Component({
  selector: 'em-unauthorized',
  templateUrl: './unauthorized.component.html',
  standalone: false,
})
export class UnauthorizedComponent {}
